import React from "react";

const ConfirmModal = ({ show, email, file, type, estimated, onClose, onSubmit }) => {
  if (!show) return null;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl shadow-xl p-8 w-full max-w-md">
        <h2 className="text-2xl font-bold mb-4">제출 전 확인</h2>
        <ul className="space-y-2 mb-6">
          <li>📧 이메일: <span className="font-semibold text-blue-700">{email}</span></li>
          <li>📄 파일: <span className="font-semibold text-blue-700">{file?.name}</span></li>
          <li>📝 작업: <span className="font-semibold text-blue-700">{type === 'proofread' ? '교정' : '교열'}</span></li>
          <li>💳 예상 소모 크레딧: <span className="font-semibold text-red-600">{estimated}</span></li>
        </ul>
        <div className="flex justify-end gap-2">
          <button
            className="px-4 py-2 rounded bg-gray-200 text-gray-700 font-semibold hover:bg-gray-300"
            onClick={onClose}
          >
            취소
          </button>
          <button
            className="px-4 py-2 rounded bg-blue-700 text-white font-bold hover:bg-blue-800"
            onClick={onSubmit}
          >
            작업 실행하기
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal; 